import { RpcService } from 'rpc';

export interface PostTestPassed {
	'main-menu': {
		passed: boolean;
		details: {
			[quiz: string]: {
				name: string;
				title: string;
				description: string;
				passed: boolean;
				score: number;
				completed: boolean;
				'score-int': number;
				pass_score: number;
				'passing-score': string;
			};
		};
	};
}

export declare interface ICertificateService extends RpcService {
	posttest_passed(params: { member_id?: string; session_id?: number }): Promise<PostTestPassed>;
}

export const svc: ICertificateService = new RpcService({
	transport: 'WEBSOCKET',
	envelope: 'JSON-RPC-2.0',
	strictParameters: false,
	target: `${window.hcstatic.portal_url}/reports/@@individual.rpc`,

	services: {
		posttest_passed: {
			parameters: [
				{
					name: 'member_id',
					type: 'string',
					optional: false
				},
				{
					name: 'session_id',
					type: 'integer',
					optional: false
				}
			]
		}
	}
}) as ICertificateService;

export default svc;
